

export function DoneAllRound(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 13L12.2277 16.3821C12.6556 16.7245 13.2793 16.6586 13.6263 16.2345L22 6" stroke="currentColor"
                  strokeWidth="2" strokeLinecap="round"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M11.1893 12.2368L15.774 6.63327C16.1237 6.20582 16.0607 5.5758 15.6333 5.22607C15.2059 4.87635 14.5758 4.93935 14.2261 5.36679L9.65279 10.9564L11.1893 12.2368ZM8.02298 16.1068L6.48647 14.8263L5.83315 15.6248L2.60006 13.2C2.15823 12.8687 1.53143 12.9582 1.20006 13.4C0.868688 13.8419 0.958231 14.4687 1.40006 14.8L4.63315 17.2248C5.49053 17.8679 6.7024 17.7208 7.38106 16.8913L8.02298 16.1068Z"
                  fill="currentColor"
                  />
        </svg>
    )
}